import Vue from 'vue';
import { Route } from 'vue-router';
import permissionGuard from './permission-guard';

const superAdminGuard = (
  to: Route,
  from: Route,
  next: (to?: string | false | void | ((vm: Vue) => void)) => void,
) => {
  return permissionGuard('isSuperAdmin', to, from, next);
};

export default superAdminGuard;
